import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@icon/triangle_right.svg'


const _hoisted_1 = { class: "multiselect__option_team-name" }
const _hoisted_2 = { class: "multiselect__option_team-name" }
const _hoisted_3 = {
  key: 2,
  class: "header__breadcrumb-menu-item_backlogs"
}
const _hoisted_4 = { class: "multiselect__option_team-name" }
const _hoisted_5 = { class: "multiselect__option__avatar" }
const _hoisted_6 = { class: "multiselect__option__name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TooltipLearn = _resolveComponent("TooltipLearn")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_DisabledFeatureTooltip = _resolveComponent("DisabledFeatureTooltip")!
  const _component_icon = _resolveComponent("icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_DropdownTooltip = _resolveComponent("DropdownTooltip")!

  return (_ctx.projectName)
    ? (_openBlock(), _createBlock(_component_DropdownTooltip, {
        key: 0,
        placement: "bottom-start",
        placementSub: "right-start",
        menu: _ctx.options,
        shown: _ctx.selectedStep === _ctx.step,
        autoHide: _ctx.selectedStep !== _ctx.step,
        popperClassSub: "sprint-selection header__breadcrumb-menu",
        popperClass: `project-selection header__breadcrumb-menu ${_ctx.selectedStep === _ctx.step ? 'pointer-none' : ''}`,
        optionMenuClass: "header__breadcrumb-menu-item",
        subMenuClass: "header__breadcrumb-menu-item",
        submenuWaitTitle: "projectTeams",
        onDropdownOptionMenu: _ctx.onTeamClick
      }, {
        after: _withCtx(() => [
          _createVNode(_component_TooltipLearn, {
            step: _ctx.step,
            show: _ctx.selectedStep === _ctx.step,
            placement: "right-bottom",
            tooltipText: _ctx.$t(`learnTooltipText.${_ctx.step}`),
            distance: 30,
            skidding: -30
          }, null, 8, ["step", "show", "tooltipText"])
        ]),
        "tooltip-label": _withCtx(() => [
          _createVNode(_component_BaseSubHeading, {
            size: "large",
            weight: "400",
            color: "monochrome-05",
            className: "header__breadcrumb"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" /"),
              _createElementVNode("span", null, _toDisplayString(_ctx.projectName), 1)
            ]),
            _: 1
          })
        ]),
        "tooltip-item": _withCtx(({ item }) => [
          (item.disabledByPlan)
            ? (_openBlock(), _createBlock(_component_DisabledFeatureTooltip, {
                key: 0,
                feature: item.feature
              }, {
                label: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["feature"]))
            : (item?.to)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: "header__breadcrumb-menu-item_backlogs router-link-wrapper",
                  to: item.to
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(item.label), 1),
                    (!item.hideOptions)
                      ? (_openBlock(), _createBlock(_component_icon, {
                          key: 0,
                          width: "6px",
                          height: "8px",
                          data: _imports_0,
                          fill: "false",
                          color: _ctx.iconColor,
                          class: "team-selection__arrow"
                        }, null, 8, ["color"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(item.label), 1),
                  (!item.hideOptions)
                    ? (_openBlock(), _createBlock(_component_icon, {
                        key: 0,
                        width: "6px",
                        height: "8px",
                        data: _imports_0,
                        fill: "false",
                        color: _ctx.iconColor,
                        class: "team-selection__arrow"
                      }, null, 8, ["color"]))
                    : _createCommentVNode("", true)
                ]))
        ]),
        "tooltip-submenu-item": _withCtx(({ option }) => [
          _createVNode(_component_router_link, {
            class: "sprint-label router-link-wrapper",
            to: {
          name: 'backlog',
          params: {
            projectId: _ctx.selectedProject.urlName,
            teamId: option.urlName
          }
        }
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_Avatar, {
                  src: option.picture?.pictureUrl,
                  size: _ctx.optionLabelSize,
                  type: "teamsGroup",
                  class: "user__avatar"
                }, null, 8, ["src", "size"])
              ]),
              _createElementVNode("span", _hoisted_6, _toDisplayString(option.name), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _: 1
      }, 8, ["menu", "shown", "autoHide", "popperClass", "onDropdownOptionMenu"]))
    : _createCommentVNode("", true)
}